import React from 'react';

const ErrorLabel = (props) => {
    return <div style={{color:"red", fontSize:"10px"}}>{props.children}</div>
}

export default ErrorLabel;